import { BaseApi, cancelInit, CancelTokenKeyCommit } from '@/main/baseApi';
import { SET_CANCEL_TOKEN } from '@/main/store/listEditTypes';

import { NAME, DMS_MODULE } from './constants';

class NastaveniTiskuProvider extends BaseApi {
	tableDataUrl() {
		return `${this.apiPath}/Rows`;
	}

	async updateList(data: Record<string, any>) {
		return this.post(`${this.apiPath}EditValue`, data);
	}
}

export const apiProvider = new NastaveniTiskuProvider(DMS_MODULE, NAME);
